<template>
  <!-- div#body:start -->
  <div id="body"
    :class="[
    {'is-hidden-header' : targetScrollFlg},
    {'is-visible-serach-settings':state.visibleBookSearchByKeyword},
    {'is-visible-menu':state.visibleMenu},
    {'is-focused-input':state.isFocusInput}
    ]"
  >
  <BackgroundImage />

    <!-- SPメニュー -->
    <SPMenu
      :parentVisibleMenu="state.visibleMenu"
      @searchByKeyword="group1.search"
      @closeMenu="state.visibleMenu = false"
    />

    <!-- 詳細検索 -->
    <transition name="popup">
      <SPQASearchDetail
        v-if="state.visibleSearchDetail"
        :startLoading="state.visibleSearchDetail"
        :parentName="'SPBookList'"
        @searchDetail="group1.searchDetail"
        @closeSearchDetail="state.visibleSearchDetail = false"
      />
    </transition>

    <!-- 絞り込み設定 -->
    <transition name="popup">
      <SPBookSearchExtract
        v-if="state.visibleBookSearchExtract"
        :parentGroup1="group1"
        @closeBookSearchExtract="state.visibleBookSearchExtract = false"
      />
    </transition>

    <!-- 後で見る -->
    <transition name="toast">
      <SPBasicToast
        v-if="state.visibleBasicToastLator"
        @closeBasicToast="state.visibleBasicToastLator = false"
      >
        後で見るに登録しました。
      </SPBasicToast>
    </transition>

    <!-- 検索条件に保存 -->
    <transition name="toast">
      <SPBasicToast
        v-if="state.visibleBasicToastSave"
        @closeBasicToast="state.visibleBasicToastSave = false"
      >
        検索条件に保存しました。
      </SPBasicToast>
    </transition>

    <div id="wrapper">

      <div id="menu-btn" class="menu-btn">
        <div role="button" class="menu-btn-1"
          style="width:82px;height:72px;"
          :class="{'is-active': state.visibleBookSearchByKeyword}"
          @click="state.visibleBookSearchByKeyword = !state.visibleBookSearchByKeyword"
        >
          <FontawesomeIcon :icon="['fas','search']" class="icn icn-closed"/>
          <FontawesomeIcon :icon="['fas','times']" class="icn icn-opened"/>
        </div>
        <div role="button" class="menu-btn-2"
          style="width:82px;height:72px;"
          @click="state.visibleMenu = true;state.visibleBookSearchByKeyword = false"
        >
          <IconMenu class="icn" />
        </div>
      </div>

      <div id="navi-btn" class="navi-btn"
        @click="state.visibleBookSearchExtract = true"
      >
        <FontawesomeIcon :icon="['fas', 'ellipsis-v']" class="icn" />
      </div>

      <!-- 検索ウインドウ -->
      <SPSearchUI 
        :screenType="'book'"
        :isAlertShown="false"
        :isSearchExecutedAtSameScreen="true"
        @search="group1.searchWithOptions"
        @searchResetOptions="group1.clearSearch"
        @openSearchDetail="state.visibleSearchDetail = true;state.visibleBookSearchByKeyword = false"
        @handleFocusOutInput="state.isFocusInput = false"
        @handleFocusInput="state.isFocusInput = true"
      />

      <!-- div#header:start -->
      <div id="header">
        <header class="header">
          <SPButtonHistoryBack :action="group1.historyBack" />
          <div class="header-title">
            <h1>書籍目次</h1>
          </div>
        </header>
      </div>

      <!-- div#header:end -->
      <div id="main">
        <div class="main">

          <div v-if="group1.isMainHeadingBookNameShown" class="main-heading">
            <div class="main-heading-row main-heading-bookinfo">
              <p class="main-heading-bookinfo-title">{{ group1.currentBookName }}</p>
            </div>
          </div>

          <div v-if="group1.isKeywordSearch" class="main-heading-row main-heading-result">
            <div v-if="group1.isMatchedTotalLoaded" class="main-heading-result-num">{{ group1.totalKeywordCount }}件</div>
            <div role="button" class="main-heading-result-link"
              :style="{'margin-left' : group1.isMatchedTotalLoaded ? '' : '0px'}"
              v-if="group1.isSearchConditionClearable" @click="group1.clearSearch"
              >検索のクリア</div>
          </div>

          <div class="main-container" 
            :class="[
            (group1.mainListType === 'contents' && group1.isPaginationForKeywordSearchShown) ? 'pb0' : '', 
            group1.scrollHeightClass]" 
            id="scroll-area">

            <template v-if="group1.mainListType === 'book'">
              <!-- 書籍一覧を表示 -->

              <!-- 書籍一覧 -->
              <FontawesomeIcon v-if="!group1.isListBookTableOfContentsLoaded" :icon="['fal','spinner-third']" size="2x" class="icn fa-spin" style="height:100%;" />
              <template v-else>
                <p v-if="!group1.booksDataExists" class="txt pt20 pl20">検索結果がありません。</p>
                <template v-else>
                  <div
                    @scroll="handleScroll"
                  >
                    <!-- パッケージ書籍 -->
                    <template v-for="item in group1.booksAreaProducts">
                      <div :key="'book_area_products_name_' + item.id" class="hdg04">{{ item.name }}</div>
                      <div :key="'book_area_products_books_' + item.id" class="list02">
                        <ul class="list02-list">
                          <li v-for="item2 in item.books" :key="'book_area_books_' + item2.id"
                            class="list02-item is-parent">
                            <div class="wrap">
                              <span class="label"
                                @click="group1.selectBook('package_book', item2.id, item2.product_id, item2.book_id, item2.name, false)"
                              >
                                <FontawesomeIcon icon="plus" class="icn-before plus" />
                                <span class="title txt-blue">{{ item2.name }} <template v-if="group1.isKeywordSearch">({{ item2.search_count }})</template></span>
                              </span>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </template>

                    <!-- パッケージ書籍と単体書籍の間のスペース -->
                    <ul v-if="group1.booksAreaProducts.length > 0 && group1.booksAreaBooks.length > 0" 
                      class="list02-list">
                      <li class="list02-item is-parent">
                        <div class="wrap">&nbsp;</div>
                      </li>
                    </ul>

                    <!-- 単体書籍 -->
                    <ul v-if="group1.booksAreaBooks.length > 0" class="list02-list">
                      <li v-for="item in group1.booksAreaBooks" :key="'book_area_books_' + item.id"
                        class="list02-item is-parent">
                        <div class="wrap">
                          <span class="label"
                            @click="group1.selectBook('single_book', item.id, item.product_id, item.book_id, item.name, false)"
                          >
                            <FontawesomeIcon icon="plus" class="icn-before plus" />
                            <span class="title txt-blue">{{ item.name }} <template v-if="group1.isKeywordSearch">({{ item.search_count }})</template></span>
                          </span>
                        </div>
                      </li>
                    </ul>
                  </div>
                </template>
              </template>
            </template>
            <template v-else-if="group1.mainListType === 'contents'">
              <!-- 選択した書籍に対する目次一覧を表示 -->

              <FontawesomeIcon v-if="!group1.isListBookTableOfContentsLoaded"
                :icon="['fal','spinner-third']" size="2x" class="icn fa-spin" style="height:100%;"/>
              <template v-else>

                <p v-if="!group1.packagesAndProductsDataExists || !group1.booksDataExists" class="txt pt20 pl20">キーワードに合致する検索結果がありませんでした。<br>検索キーワードを変更して再度検索してください。</p>
                <template v-else>

                  <div
                    @scroll="handleScroll"
                  >
                    <div class="list02">
                      <div class="list02-back">
                        <div class="wrap">
                          <div @click.prevent.stop="group1.onListTitleOfTableOfContentsOfSPClicked" class="label">
                            <FontawesomeIcon icon="angle-left" class="icn-before" />
                            <!-- タイトル1行目 -->
                            <a class="title txt-blue"><span v-html="group1.currentTitleFirstLine"></span><span v-if="group1.keywordCountInPage > 0"> （画面内に{{ group1.keywordCountInPage }}件）</span></a>
                            <!-- タイトル2行目以降 -->
                            <template v-for="(line, index) in group1.currentTitleAfterSecondLines">
                              <span :key="'current_title_second_line_' + index" class="indent" v-html="line"></span>
                            </template>
                          </div>
                        </div>
                      </div>

                      <ul class="list02-list">
                        <li v-for="(item, index) in group1.currentTableOfContents" 
                          :key="'table_of_contents_' + index"
                          class="list02-item"
                          :class="{ 'is-parent': typeof item.children !== 'undefined' && item.children.length > 0 }"
                        >
                          <div class="wrap">
                            <div @click.prevent.stop="group1.onItemOfTableOfContentsOfSPClicked(item)" class="label">
                              <FontawesomeIcon icon="plus" class="icn-before plus" v-if="typeof item.children !== 'undefined' && item.children.length > 0" />
                              <!-- タイトル1行目 -->
                              <span class="title txt-blue" v-html="item.title_first_line"></span>
                              <!-- タイトル2行目以降 -->
                              <template v-for="(line, index) in item.title_after_second_lines">
                                <span :key="'second_line_' + index" class="indent" v-html="line"></span>
                              </template>                              
                            </div>
                            <ButtonViewLater
                              v-if="!(typeof item.children !== 'undefined' && item.children.length > 0) && item.type != 3"
                              :afterId="item.after_id"
                              :paramId="item.id"
                              :paramKey="'qa'"
                              :gaClass="'ga-book-list-view-later'"
                              @onViewLaterChanged="group1.onViewLaterChanged"
                             />
                          </div>
                        </li>
                      </ul>

                    </div>
                  </div>

                </template>
              </template>

              <div v-if="group1.isPaginationForKeywordSearchShown" class="pagenation-wrp">
                <div class="pagenation">

                  <a v-if="group1.hasPrevPageForSPKeywordSearch"
                    class="pagenation-link prev" 
                    @click="group1.updateTableOfContentsForSPKeywordSearch(group1.currentNodeId, false, false, false)" 
                    role="button"
                  >{{ group1.prevPageNoForSPKeywordSearch }} <FontawesomeIcon :icon="['far','angle-left']" size="1x" class="icn icn-arrow" /> 前へ</a>
                  <a v-else-if="group1.prevBookForSPKeywordSearch"
                    @click="group1.selectBook(group1.prevBookForSPKeywordSearch.book_type, group1.prevBookForSPKeywordSearch.id, group1.prevBookForSPKeywordSearch.product_id, group1.prevBookForSPKeywordSearch.book_id, group1.prevBookForSPKeywordSearch.name, true)"
                    class="pagenation-link prev"
                    role="button"
                  >前の書籍</a>
                  <span v-else class="pagenation-link prev" >&nbsp;</span>

                  <a v-if="group1.hasNextPageForSPKeywordSearch"
                    class="pagenation-link next" 
                    @click="group1.updateTableOfContentsForSPKeywordSearch(group1.currentNodeId, false, true, false)" 
                    role="button"
                  >次へ <FontawesomeIcon :icon="['far','angle-right']" size="1x" class="icn icn-arrow" /> {{ group1.nextPageNoForSPKeywordSearch }}</a>
                  <a v-else-if="group1.nextBookForSPKeywordSearch"
                    @click="group1.selectBook(group1.nextBookForSPKeywordSearch.book_type, group1.nextBookForSPKeywordSearch.id, group1.nextBookForSPKeywordSearch.product_id, group1.nextBookForSPKeywordSearch.book_id, group1.nextBookForSPKeywordSearch.name, false)"
                    class="pagenation-link prev"
                    role="button"
                  >次の書籍</a>
                  <span v-else class="pagenation-link next">&nbsp;</span>

                </div>
              </div>

            </template>

          </div>
        </div>
      </div>


    </div>
  </div>
  <!-- div#body:end -->
</template>

<script>
import { defineComponent, reactive, ref, computed } from '@vue/composition-api'

import SPSearchUI from '@/components/sp/partial/SPSearchUI.vue'
import SPMenu from '@/components/sp/popup/SPMenu.vue'
import SPQASearchDetail from '@/components/sp/popup/SPQASearchDetail.vue'
import SPBookSearchExtract from '@/components/sp/popup/SPBookSearchExtract.vue'
import SPBasicToast from '@/components/sp/popup/SPBasicToast.vue'

import * as logicBookList from '@/logic/qa/BookList'

export default defineComponent({
  components: {
    SPSearchUI,
    SPMenu,
    SPQASearchDetail,
    SPBookSearchExtract,
    SPBasicToast
  },
  setup (props, context) {

    const { group1, state } = logicBookList.getGroup(props, context)
   
    return {
      group1,
      state
    }
  }
})
</script>

<style lang="scss" scoped>
.main {
  &-heading {
    &-bookinfo {
      padding: 20px;
      background-color: $color-bg-paper;
      &-title {
        color: $color-sup;
        font-size: 1.2rem;
      }
    }
  }
  &-heading-row {
    height: $sp-main-heading-height;
  }
  &-container {
    @include changeHeightOnScroll($sp-header-height);
    &.is-1-main-heading-shown {
      @include changeHeightOnScroll($sp-header-height + $sp-main-heading-height);
    }
    &.is-2-main-heading-shown {
      @include changeHeightOnScroll($sp-header-height + $sp-main-heading-height * 2);
    }
    .hdg04 {
      padding: 20px;
      margin-bottom: 0;
      border-bottom: 1px solid $color-line;
    }
  }
}
.menu-btn {
  &-1 {
    .icn {
      transition: all .2s ease;
    }
    .icn-opened {
      opacity: 0;
    }
    .icn-closed {
      opacity: 1;
    }
  }
}

.is-visible-serach-settings {
  .menu-btn {
    // transform: translate3d(0,-128px,0);
    transform: translate3d(0,-271px,0);
    &-1 {
      .icn {
        transition: all .2s ease;
      }
      .icn-opened {
        opacity: 1;
      }
      .icn-closed {
        opacity: 0;
      }
    }
  }
  .search-settings {
    transform: translate3d(0,0,0);
    box-shadow: 0 -8px 8px rgba(0,0,0,.16);
  }
}

.pagenation {
  max-width: 400px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  background-color: #fff;
  border: 1px solid $color-line;
  border-radius: 6px;
  &-wrp {
    background-color: $color-bg-paper;
    padding: 20px 20px 100px;
    &.is-open {
      padding-bottom: 330px;
    }
  }
  &-link {
    display: flex;
    justify-content: center;
    align-items: center;
    color: $color-link;
    font-size: 1.4rem;
    height: 48px;
    flex: 0 1 50%;
    .icn {
      margin: 0 5px;
    }
    &.first,&.prev {
      border-right: 1px solid $color-line;
    }
    &.last,&.next {
      border-left: 1px solid $color-line;
    }
  }
}

</style>
